/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_MaintenanceInputs */



/**
* | output |
* | --- |
* | "View on the \"maintenance\" page" |
*
* @param {Dashboard_MaintenanceInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const dashboard_maintenance = /** @type {((inputs?: Dashboard_MaintenanceInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_MaintenanceInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("View on the \"maintenance\" page")
	return /** @type {LocalizedString} */ ("Voir sur la page \"maintenance\"")
});